//Redux Toolkit
import { createSelector } from "@reduxjs/toolkit";

//Selectors
import { selectCurrentMatchedPage } from "./select-current-matched-page";
import { selectTotalPages } from "./select-total-pages";
import { selectFacetedResults } from "../facets/select-faceted-results";
import { selectIsMobile } from "../../../../system/redux/selectors/select-is-mobile";

//Constants
import {
	_mobileResultsPerPage,
	_resultsPerPage,
} from "../../../constants/paginaton-settings";

//Util
import { getPageOfResults } from "../../../functions/pagination/get-page-of-results";

/** Returns all of the matched results up to the current page.  The matched/main result
 * list uses this to show the current page of results which change as the user uses the
 * pagination links.
 */
export const selectPageOfMatchedResults = createSelector(
	[
		selectFacetedResults,
		selectCurrentMatchedPage,
		selectTotalPages,
		selectIsMobile,
	],
	(results, currentPage, totalPages, isMobile) => {
		let numberOfResultsPerPage = _resultsPerPage;
		if (isMobile) {
			numberOfResultsPerPage = _mobileResultsPerPage;
		}

		return getPageOfResults(
			results?.MatchedResults,
			currentPage,
			numberOfResultsPerPage,
			totalPages,
		);
	},
);
